/**
 * Check if value do not exceed the max item
 * @param {Array} value - array value
 * @returns {boolean}
 */
export default function isNotExceedMax(value, max) {
  return Array.isArray(value) && value.length <= max;
}
